import React from 'react'
import style from './servicesPage.module.css'
import {useState} from 'react'
import {servicesData} from './services.Data.js'

const ServicesPage = () => {

    const [servicesInfo,
        setServiceInfo] = useState(servicesData)

    const process = [
        {
            step: "01",
            title: "Écoute",
            description: "Nous prenons le temps de comprendre vos besoins, vos défis et vos ambitions"
        }, {
            step: "02",
            title: "Analyse",
            description: "Nous étudions votre contexte pour proposer des solutions adaptées"
        }, {
            step: "03",
            title: "Action",
            description: "Nous mettons en œuvre les solutions avec rigueur et agilité"
        }, {
            step: "04",
            title: "Suivi",
            description: "Nous vous accompagnons dans la durée pour garantir votre succès"
        }
    ]

    return (
        <div className={style.mainServices}>
            {/* Hero Section */}
            <div className={style.heroSection}>
                <div className={style.containerHead}>
                    <h1>Nos Services</h1>
                    <p className={style.subtitle}>
                        Des solutions concrètes, adaptées à vos besoins réels
                    </p>
                    <p className={style.description}>
                        Notre activité principale consiste à assister les entreprises dans la mise en
                        œuvre des systèmes de gestion et dans la production de leurs informations de
                        communication stratégique.
                    </p>
                </div>
            </div>

            {/* Services Grid */}
            <div className={style.servicesSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Notre Offre de Services</h2>
                    <div className={style.servicesGrid}>
                        {servicesInfo.map((service, index) => (
                            <div key={index} className={style.serviceCard}>
                                <div className={style.serviceIcon}>{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p className={style.serviceDescription}>{service.description}</p>
                                <ul className={style.featuresList}>
                                    {service
                                        .features
                                        .map((feature, i) => (
                                            <li key={i}>
                                                <span className={style.checkmark}>✓</span>
                                                {feature}
                                            </li>
                                        ))}
                                </ul>
                                <button className={style.serviceBtn}>En savoir plus</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Process Section */}
            <div className={style.processSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Notre Approche</h2>
                    <p className={style.processIntro}>
                        Une méthodologie éprouvée en 4 étapes pour garantir votre réussite
                    </p>
                    <div className={style.processGrid}>
                        {process.map((item, index) => (
                            <div key={index} className={style.processCard}>
                                <div className={style.processStep}>{item.step}</div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                                {index < process.length - 1 && (
                                    <div className={style.processArrow}>→</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Why Choose Us */}
            <div className={style.whySection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Pourquoi Get-Conseil ?</h2>
                    <div className={style.whyGrid}>
                        <div className={style.whyCard}>
                            <h3>⚡ Réactivité</h3>
                            <p>Des délais respectés et une communication fluide à chaque étape</p>
                        </div>
                        <div className={style.whyCard}>
                            <h3>🎓 Expertise</h3>
                            <p>Une équipe de spécialistes maîtrisant les dernières technologies</p>
                        </div>
                        <div className={style.whyCard}>
                            <h3>🤝 Proximité</h3>
                            <p>Un accompagnement personnalisé et une présence à vos côtés</p>
                        </div>
                        <div className={style.whyCard}>
                            <h3>💎 Qualité</h3>
                            <p>Des livrables soignés qui dépassent vos attentes</p>
                        </div>
                        <div className={style.whyCard}>
                            <h3>🚀 Engagement</h3>
                            <p>
                                Le cabinet « GET CONSEIL » se positionne comme un partenaire-conseil
                                stratégique, accompagnant durablement votre entreprise dans la prise de
                                décision.</p>
                        </div>
                        <div className={style.whyCard}>
                            <h3>🔍 Audit</h3>
                            <p>
                                Nous réalisons des missions d’audit ciblées afin d’évaluer la conformité et la
                                fiabilité d’informations financières ou non, en référence à des normes
                                préétablies.
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className={style.ctaSection}>
                <div className={style.ctaContainer}>
                    <h2>Prêt à démarrer votre projet ?</h2>
                    <p>Nos missions s’adaptent aux besoins et aux priorités de nos clients, à chaque
                        étape du projet, depuis sa phase de conception jusqu’à sa mise en œuvre. Nous
                        restons pleinement disponibles afin d’accompagner efficacement la réalisation de
                        vos objectifs.</p>
                    <div className={style.ctaButtons}>
                        <button className={style.primaryBtn}>Demander un devis</button>
                        <button className={style.secondaryBtn}>Prendre rendez-vous</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServicesPage